import { render } from "./TheSpace.vue?vue&type=template&id=4361cae0&scoped=true"
import script from "./TheSpace.vue?vue&type=script&lang=js"
export * from "./TheSpace.vue?vue&type=script&lang=js"

import "./TheSpace.vue?vue&type=style&index=0&id=4361cae0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4361cae0"]])

export default __exports__